import { Icon } from "@iconify/react/dist/iconify.js";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import "./style.css";
import SideCol from "../../../shared/SideCol/SideCol";
import ActionBtn from "@/components/ActionBtn";
import TextBox from "../../../shared/TextBox/TextBox";
import { SideSection } from "../../../shared/SideCol/SideSection";
import useNavs from "@/hooks/useNavs";
import { useCallback } from "react";

const OpsValuation = ({ data }) => {
  const { t } = useTranslation();
    const { AccountManagerNav } = useNavs();
    const { id, medicalOrderId, hospitalRequestId } = useParams();
  const { price, addsOnPrice, paymentPercentage, paymentTerms, refundPolicy, slaNote } = data || {};

  const packageBase = price || 0;
  const addonsTotal = addsOnPrice || 0;
  const total = packageBase + addonsTotal;
  const downPayment = total * (parseFloat(paymentPercentage) / 100 || 0.25);

  const fmt = (n) =>
    `$${Number(n).toLocaleString("en-US", { minimumFractionDigits: 2 })}`;

    const handleBack = useCallback(() => AccountManagerNav(`medical-requests/${id}/${medicalOrderId}`), [AccountManagerNav]);
  

  return (
    <SideCol
      title={t("ops-valuation")}
      icon="solar:calendar-bold-duotone"
      className="bg-white ov-card"
    >
      <SideSection title={t("package-base")} value={fmt(packageBase)} />
      <SideSection title={t("addons-total")} value={fmt(addonsTotal)} />
      <div className="qs-divider" />
      <SideSection title={t("total-price")} value={fmt(total)} />

      <div className="qs-notice">
        <Icon icon="solar:info-circle-outline" className="qs-notice-icon" />
        <p>
          {t("down-payment-notice", {
            pct: `${paymentPercentage || 25}%`,
            amount: fmt(downPayment),
          })}
        </p>
      </div>

      

      <TextBox
        title={t("payment-terms")}
        text={paymentTerms}
        className="qs-note-text bg-white mb-3"
        textBoxClassName="bg-transparent border-0 p-0"
      />

      <TextBox
        title={t("refund-policy")}
        text={refundPolicy}
        className="qs-note-text bg-white mb-3"
        textBoxClassName="bg-transparent border-0 p-0"
      />

      {slaNote && (
        <TextBox
          title={t("sla-compliance")}
          className="ov-sla-box my-3"
          textBoxClassName="border-0 bg-transparent p-0 "
          text={slaNote}
        />
      )}
      <ActionBtn
        className="ov-back-btn mt-auto"
        onApply={handleBack}
        title={t("back-to-evaluation")}
      />
    </SideCol>
  );
};

export default OpsValuation;
